import { render, staticRenderFns } from "./DeleteCombo.vue?vue&type=template&id=c1bfb9be&"
import script from "./DeleteCombo.vue?vue&type=script&lang=js&"
export * from "./DeleteCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports